import { MarcaCompania } from "@/componentes/impresos/MarcaCompania"
import { Ondas } from "@/componentes/impresos/Ondas"
import { dato, filete, titular, versal } from "./estilo"
import { MEDIDAS } from "./medidas"
import type { DatosTejuelo } from "./tipos"

/** La etiqueta del libro legal. La empresa dueña del libro puede no ser la agencia. */
export function TejueloLibro({ datos }: { datos: DatosTejuelo }) {
  const { ancho, alto } = MEDIDAS.TEJUELO

  return (
    <article
      className="pieza-impresa"
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "3mm",
        width: `${ancho}mm`,
        height: `${alto}mm`,
        padding: "8mm 10.6mm",
        textAlign: "center",
        fontFamily: "var(--font-rotulo-texto)",
      }}
      aria-label={`Tejuelo: ${datos.libro || "sin libro"}`}
    >
      <Ondas pieza="tejuelo" style={{ left: 0, bottom: 0, width: "100%", height: "29mm" }} />
      <MarcaCompania compania={datos.compania} alto={17} />
      <div style={filete({ width: "12.7mm" })} />
      {datos.codigo ? <p style={versal(2.9)}>{datos.codigo}</p> : null}
      <h1
        style={titular(datos.libro.length > 26 ? 7.4 : 10.6, {
          letterSpacing: "-0.02em",
          position: "relative",
        })}
      >
        {datos.libro}
      </h1>
      {datos.detalle ? (
        <p style={dato(4.5, { color: "var(--impreso-texto-3)", position: "relative" })}>
          {datos.detalle}
        </p>
      ) : null}
      {datos.empresa ? (
        <p style={dato(3.1, { color: "var(--impreso-texto-2)", position: "relative" })}>
          {datos.empresa}
          {datos.rif ? ` · RIF ${datos.rif}` : ""}
        </p>
      ) : null}
    </article>
  )
}
